<template>
  <div
    id="app"
    v-loading.fullscreen.lock="el_loading_x||el_loading_long_x"
    element-loading-background="rgba(0,0,0,0)">
    <!-- element-loading-text="LOADING..."
    element-loading-spinner="el-icon-loading" -->
    <keep-alive :include="['index','lock']">
      <router-view />
    </keep-alive>
    <!-- <router-view @playMusic="playMusic"/>
    <audio ref="audio">
      <source src="@/assets/music/bell.mp3" type="audio/mpeg"/>
      Your browser does not support the audio element.
    </audio> -->
    <EasyRing :open="bellOpen_x" :ring="bellRing_x" :src="bellSrc" />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import mixin_preventUnload from '@/mixins/mixin_preventUnload'
import { EasyRingVueComponent as EasyRing } from 'easy-ring'
export default {
  mixins: [mixin_preventUnload],
  components: { EasyRing },
  data() {
    return {
      bellSrc: require('@/assets/music/bell.mp3'),
    }
  },
  methods: {
    ...mapMutations([
      'aliUrl_x_save',
      'sysEnv_x_save',
      'networkStatus_x_save',
    ]),
    // 获取系统环境
    getSysEnv() {
      this.$api.sysenv_search().then(res => {
        if (res.status == 0) {
          let _R = res.data
          this.sysEnv_x_save(_R['dola.service.version'])
          console.log('%c系统环境:', 'color: #ff0;', _R)
        } else { this._status(res) }
      })
    },
    // 获取图片终端
    getAliUrl() {
      this.$api.aliyun_search().then(res => {
        if (res.status == 0) {
          let _R = res.data
          if (_R.indexOf('http')) {
            _R = 'https://' + _R
          }
          this.aliUrl_x_save(_R)
          console.log('%c图片终端:', 'color: #ff0;', _R)
        } else { this._status(res) }
      })
    },
    // playMusic() {
    //   this.$refs.audio.play()
    // },
  },
  async created() {
    this.getSysEnv()
    this.getAliUrl()

    window.addEventListener("offline", () => {
      console.log(`%c已断网`, 'color: #ff0;', )
      this.networkStatus_x_save(false)
    })
    window.addEventListener("online", () => {
      console.log(`%c网络已连接`, 'color: #ff0;', )
      this.networkStatus_x_save(true)
    })
  },
}
</script>

<style lang="scss">
// 禁止长按
* {
  -webkit-touch-callout:none;
  -webkit-user-select:none;
  -khtml-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
}
input {      
  -webkit-user-select:auto; /*webkit浏览器*/     
} 

#app {
  // min-width: 1240px;
  height: 100%;
  background: #fff;
}

@import '@/assets/css/base.scss';
@import '@/assets/css/util_base.scss';
.el-popover{padding: 6px 0!important;}

.imgsquarebox{
  width: 100%;padding-top: 100%;height: 0;position: relative;
  &>div, &>img{position: absolute;top: 0;width: 100%;height: 100%;}
}
// 禁止選擇
*{
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently not supported by any browser */
}
</style>
